import { createRef } from 'lit/directives/ref.js';

/**
 * Reference to the main scroll container.
 * Used for auto-scrolling behaviors.
 */
export const mainScrollContainer = createRef<HTMLElement>();
